import {Button} from "primereact/button";
import React from "react";
import {useTranslation} from "react-i18next";

import type {ValueOrderDocument} from "@reva/shared/value-order";

import {rerunIdpEnergyAsync, selectIdpEnergyLoading} from "../../redux/idpEnergySlice";
import {useRevaDispatch, useRevaSelector} from "../../redux/revaHooks";

interface IdpEnergyRerunButtonProps {
    /** Der aktuell im EAusweis-Reiter gewählte Energieausweis, auf dem die IDP-Extraktion erneut laufen soll. */
    document?: ValueOrderDocument;
}

/**
 * Permission-gated (reva-idp-energy): re-run the IDP extraction on the CURRENTLY SELECTED energy certificate (the active
 * sub-tab). Sits between the upload and the JSON-paste buttons. Only rendered when the selected document is
 * a PDF (the IDP-Energy /energy-certificate endpoint is PDF-only — same restriction as the upload auto-trigger).
 * When the result arrives, the IDP layer's {@code energy_certificate_file_name} is replaced, which moves the
 * "evaluated" highlight to this document's tab.
 */
export default function IdpEnergyRerunButton({document}: IdpEnergyRerunButtonProps): React.ReactNode {
    const {t} = useTranslation();
    const dispatch = useRevaDispatch();
    const loading = useRevaSelector(selectIdpEnergyLoading);

    const isPdf = document?.extension?.toLowerCase() === "pdf";

    if (!document || !isPdf) {
        return null;
    }

    return (
        <Button
            label={t("object.energy.idp.rerun.button")}
            icon="pi pi-refresh"
            size="small"
            outlined
            loading={loading}
            onClick={() => void dispatch(rerunIdpEnergyAsync(document))}
        />
    );
}
